/**
 * Phone number formatting helpers.
 *
 * Format-as-you-type US 10-digit phone: `(###) ###-####`
 *
 * Iter18 §1.3 — shared formatter for all Settings phone fields (and downstream
 * customer / crew / user forms). Non-digits are stripped; the input string is
 * limited to 10 digits and reformatted to the canonical mask.
 */

/**
 * Format a raw string as a US phone number using progressive masking.
 * @param {string} value  Raw input (may contain non-digits).
 * @returns {string} Formatted phone string, e.g. "(415) 555-1234".
 */
export function formatPhoneInput(value) {
  if (value == null) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/**
 * Return just the 10-digit form (no formatting) for storage / comparisons.
 * @param {string} value
 * @returns {string} digits-only, up to 10 chars.
 */
export function toPhoneDigits(value) {
  if (value == null) return '';
  return String(value).replace(/\D/g, '').slice(0, 10);
}

/**
 * Format a stored digits-only phone for display.
 * @param {string} digits
 * @returns {string}
 */
export function formatPhoneForDisplay(digits) {
  return formatPhoneInput(digits);
}
